import React from 'react';
import Snackbar from '@material-ui/core/Snackbar';
import { connect } from 'react-redux';
import { dismissSnack } from '../actions/uiActions';
import { getPopulatedSnack } from '../reducers/ui.snackbar';

class SnackBar extends React.Component {

    state = {
        snack: null,
        visible: false,
    };

    componentDidMount() {
        if (this.props.snack) {
            this.showSnack(this.props.snack);
        }
    }

    componentWillReceiveProps(nextProps) {
        const snack = this.props.snack;
        const nextSnack = nextProps.snack;
        const visibleSnack = this.state.snack;
        const isInactive = this.props.inactive;
        const willInactivate = nextProps.inactive;
        if (!willInactivate && ((nextSnack && !snack) || (nextSnack && (nextSnack.id !== (snack || {}).id)))) {
            this.showSnack(nextSnack); // Active, and a new snack stands in line in the queue. Show it!
        }
        else if (isInactive && !willInactivate && (snack && !visibleSnack)) {
            this.showSnack(snack); // Will be active, and we have a snack. Show it!
        }
        else if (!isInactive && willInactivate && visibleSnack) {
            this.hideSnack(); // Will deactivate, remove the snack until we become active again
        }
        else if (!nextSnack && snack) {
            this.hideSnack(); // The current snack has been removed from the queue, no one stands in line. Hide it!
        }
    }

    componentWillUnmount() {
        this.clearDismissTimer();
    }

    showSnack = snack => {
        this.hideSnack().then(() => {
            this.setState({ snack, visible: false });
            setTimeout(() => {
                this.setState({ visible: true });
                if (snack.autohide) {
                    this.snackTimer = setTimeout(() => {
                        this.props.dismissSnack(snack.id);
                    }, snack.autohide);
                }
            }, 1);
        });
    };

    transitionEndHandler = () => {
        if (this.afterTransition) {
            this.afterTransition();
            this.afterTransition = null;
        }
    };

    hideSnack = () => {
        if (!this.state.snack) {
            return Promise.resolve();
        }
        return new Promise(resolve => {
            this.clearDismissTimer();
            this.setState({ visible: false });
            this.afterTransition = () => {
                this.setState({ snack: null });
                resolve();
            };
        });
    };

    clearDismissTimer = () => {
        if (this.snackTimer) {
            clearTimeout(this.snackTimer);
            this.snackTimer = null;
        }
    };

    render() {
        const { snack } = this.state;

        if (!snack) {
            return null;
        }

        // const Action = snack.action || null;

        return (
            <Snackbar
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                onTransitionEnd={this.transitionEndHandler}
                open={this.state.visible}
                onClose={this.hideSnack}
                SnackbarContentProps={{
                    'aria-describedby': 'message-id',
                }}
                message={<span id={snack.id}>{snack.label}</span>}
            />
        );
    }
}

const mapDispatchToProps = dispatch => ({
    dismissSnack: id => dispatch(dismissSnack(id)),
});

const mapStateToProps = state => ({
    snack: getPopulatedSnack(state),
});

export default connect(mapStateToProps, mapDispatchToProps)(SnackBar);



// WEBPACK FOOTER //
// ./src/components/SnackBar.js